import { useTranslation } from 'react-i18next';

interface FAQCategoriesProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const FAQCategories = ({ activeCategory, onCategoryChange }: FAQCategoriesProps) => {
  const { t } = useTranslation();

  const categories = [
    { id: 'all', name: t('faq:categories.all'), icon: 'ri-apps-line' },
    { id: 'general', name: t('faq:categories.general'), icon: 'ri-information-line' },
    { id: 'pdf', name: t('faq:categories.pdf'), icon: 'ri-file-pdf-line' },
    { id: 'image', name: t('faq:categories.image'), icon: 'ri-image-line' },
    { id: 'security', name: t('faq:categories.security'), icon: 'ri-shield-check-line' },
    { id: 'account', name: t('faq:categories.account'), icon: 'ri-user-line' }
  ];

  return (
    <section className="sticky top-16 z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`flex items-center gap-2 px-6 py-3 rounded-full text-base font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeCategory === category.id
                  ? 'bg-teal-600 text-white shadow-lg shadow-teal-600/30'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className={`${category.icon} text-xl`}></i>
              <span>{category.name}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQCategories;